import React from 'react';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import moment from 'moment';

function Footer() {
    return (
        <div className="-mt-40 pb-56 lg:pb-0 pt-44 text-center h-72 max-h-full bg-gradient-to-r from-sbBrightGreen to-sbBrightBlue">
            <Container maxWidth="xl">
                <div className="lg:flex flex-row items-center">
                    <div className="text-white text-sm flex-1">
                        ©{moment().year()} - SimplyBorrowed Inc.{' '}
                    </div>
                    <div className="text-white text-4xl font-bold flex-auto">
                        <Link to="/help">
                            Need Help <ContactSupportIcon fontSize="large" />{' '}
                        </Link>
                    </div>
                    <div className="text-white text-sm flex-1">
                        SimplyBorrowed's Customer Portal
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Footer;
